import { createSlice } from "@reduxjs/toolkit";

const initialState = "";

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme: (state, { payload }) => {
      return payload;
    },
  },
});

export const { setTheme } = themeSlice.actions;

export default themeSlice.reducer;
